import React, { useEffect, useRef, useState } from "react";
import MenuIcon from "./MenuIcon";
import { Link } from "react-router-dom";

const Menu = ({ list, firstIcon, secondIcon }) => {
  const [isOpen, setOpen] = useState(false);
  const menuRef = useRef(null);

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={menuRef} className=" relative text-text-1/75">
      <MenuIcon
        toggle={setOpen}
        toggled={isOpen}
        firstIcon={firstIcon}
        secondIcon={secondIcon}
      />
      {isOpen && (
        <div className="absolute bg-bkg2 border z-10 border-bkg2 rounded top-6 right-0 flex flex-col justify-center items-center overflow-hidden">
          {list.map((item, index) => (
            <div key={index}>
              {item.type === "link" ? (
                <div className="" key={index}>
                  <Link
                    className="border-b py-1.5 px-7 last:border-none hover:bg-bkg inline-block"
                    // to={`${location.pathname}/details/${item.id}`}
                    to={"#"}
                  >
                    {item.text}
                  </Link>
                </div>
              ) : (
                <div className="" key={index}>
                  <button className="border-b py-1.5 px-7 last:border-none hover:bg-bkg inline-block">
                    {item.text}
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Menu;
